import { immerable } from 'immer';
import { stageCaps } from '../common/stageConstants'
import { stageGoals } from '../common/stageConstants'

export default class ChatSession {
  constructor(sessionId) {
    this.sessionId = sessionId || '';
    this.messages = {
        invitation: [
            { type: 'newStage', message: 'invitation' },
            { type: 'chatbot', message: "I'm an AI conflict coach here to help you with any conflicts or issues you may be facing. How can I assist you today?" }
        ],
        connection: [],
        exchange: [],
        agreement: [],
        reflection: []
    };
    this.time = new Date().toISOString();
    this.stage = "invitation"
    this.atStartRef = false;
    this.refusalCap = 100;
    this.refusalCapCount = 0;
    this.completed = false;
    this[immerable] = true;
    this.messageCap =  {
      invitation: {
        msgCount: 0,
        msgCap: stageCaps.invitation
      },
      connection: {
        msgCount: 0,
        msgCap: stageCaps.connection
      },
      exchange: {
        msgCount: 0,
        msgCap: stageCaps.exchange
      },
      agreement: {
        msgCount: 0,
        msgCap: stageCaps.agreement
      },
      reflection: {
        msgCount: 0,
        msgCap: stageCaps.reflection
      }
    }
    this.sessionName = 'New Chat';
    this.moveStageStatus = {
      onMoveStage: false,
      isMinimized: false,
      checkList: Object.entries(stageGoals).reduce((acc, [stage, goals]) => {
        acc[stage] = goals.map((goal, index) => ({
          id: index, 
          text: goal,
          checked: false
        }));
        return acc;
      }, {})
    }
  }

  toPlainObject() {
    return {
      sessionId: this.sessionId,
      messages: this.messages,
      time: this.time,
      stage: this.stage,
      atStartRef: this.atStartRef,
      refusalCap: this.refusalCap,
      refusalCapCount: this.refusalCapCount,
      completed: this.completed,
      messageCap: this.messageCap,
      sessionName: this.sessionName,
      moveStageStatus: this.moveStageStatus,
    };
  }

  setSessionName(newName) {
    this.sessionName = newName === '' ? 'New Chat' : newName;
  }

  setMessageCap(messageCap) {
    Object.entries(messageCap).forEach(([stage, cap]) => {
      if (this.messageCap.hasOwnProperty(stage)) {
        this.messageCap[stage].msgCap = cap;
      }
    });
  }
}